<script>
    import BarChart from "./BarChart.svelte";
    import SingleNumberChart from "./SingleNumberChart.svelte";
    import Rest from "../public/lib/rest";
    import moment from 'moment'
    import LineChart from "./LineChart.svelte";
    import Cookies from "../public/vendor/js-cookie/js.cookie";

    let DAILY_COST = 0;

    let reportData = {
        financeStatsForCurrentMonth: {}
    };
    let incomeDetailsShown = false;

    let financialChart;
    let carPaymentsChart;
    let clientsCount;
    let incomePerDay;

    let totalCarPrice = 0;
    let totalCarPaid = 0;
    let dailyIncome = 0;
    let lasowiceCash = 0;
    let nettoFromBeginningOfTheMonth = 0;

    let shouldShowOverallStats = false;

    export function setup(data) {
        reportData = data;

        reportData.financeStatsForCurrentMonth.incomeDetails.forEach(o => {
            //o.date = moment.unix(o.date / 1000).format('DD-MM-YYYY');
        });

        financialChartData.labels = [];
        financialChartData.data = [];

        for (const [key, value] of Object.entries(reportData.financialReport)) {
            financialChartData.labelsData.push(key);
            financialChartData.valuesData.push(value);
        }

        clientsCount = data.clientsCount;
        incomePerDay = data.incomePerDay;
        lasowiceCash = data.lasowiceCash;
        nettoFromBeginningOfTheMonth = data.financeStatsForCurrentMonth.incomeNetto - data.financeStatsForCurrentMonth.costsNetto - data.financeStatsForCurrentMonth.carCosts;

        data.cars.sort((a, b) => {
            let aPaid = a.paid >= a.totalPrice;
            let bPaid = b.paid >= b.totalPrice;

            if (aPaid ^ bPaid) {
                if (aPaid) {
                    return -1
                } else {
                    return 1;
                }
            } else {
                if (aPaid) {
                    return a.totalPrice - b.totalPrice;
                } else {
                    return (a.totalPrice - a.paid) - (b.totalPrice - b.paid);
                }
            }
        }).forEach((car) => {
            carPaymentsChartData.labelsData.push(car.name + ' - ' + car.registrationNumber);
            carPaymentsChartData.valuesData.push((car.paid).toFixed(0));
            carPaymentsChartData.valuesData2.push((car.totalPrice - car.paid).toFixed(0));
            totalCarPaid += parseInt((car.paid).toFixed(0));
            totalCarPrice += parseInt((car.totalPrice).toFixed(0));
            DAILY_COST += car.nettoCostPerDay;
        });

        dailyIncome = DAILY_COST * -1;

        carPaymentsChartData.titleData = ' Poziom spłaty aut (netto)  -  ' + totalCarPaid + '  /  ' + totalCarPrice + '   -   ' + (100 * totalCarPaid / totalCarPrice).toFixed(1) + '%';

        setTimeout(function () {
            carPaymentsChart.setup();
            if(shouldShowOverallStats) {
                financialChart.setup();
            }

            if (data.incomePerDay > 0) {


                jQuery('#foo').css({'width': jQuery('#foo').parent().width() + 'px'});
                jQuery('#foo').css({'height': (jQuery('#foo').parent().width() / 2 - 1) + 'px'});

                var opts = {
                    staticLabels: {
                        font: "38px",  // Specifies font
                        labels: [0, 200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400],  // Print labels at these values
                        color: "#ffffff",  // Optional: Label text color
                        fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                    },
                    staticZones: [
                        {strokeStyle: "#F03E3E", min: 0, max: DAILY_COST / 2},
                        {strokeStyle: "#FFDD00", min: DAILY_COST / 2, max: DAILY_COST},
                        {strokeStyle: "#30B32D", min: DAILY_COST, max: 2400}
                    ],
                    angle: -0.2, // The span of the gauge arc
                    lineWidth: 0.2, // The line thickness
                    radiusScale: 1, // Relative radius
                    pointer: {
                        length: 0.6, // // Relative to gauge radius
                        strokeWidth: 0.035, // The thickness
                        color: '#000000' // Fill color
                    },
                    limitMax: false,     // If false, max value increases automatically if value > maxValue
                    limitMin: false,     // If true, the min value of the gauge will be fixed
                    colorStart: '#6FADCF',   // Colors
                    colorStop: '#8FC0DA',    // just experiment with them
                    strokeColor: '#E0E0E0',  // to see which ones work best for you
                    generateGradient: true,
                    highDpiSupport: true,     // High resolution support

                };
                var target = document.getElementById('foo'); // your canvas element
                var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
                gauge.maxValue = 2400; // set max gauge value
                gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
                gauge.animationSpeed = 32; // set animation speed (32 is default value)
                gauge.set(data.incomePerDay); // set actual value

                dailyIncome += data.incomePerDay;
            }
        }, 100);

        let name = Cookies.get('name');
        shouldShowOverallStats = (name != 'Paulina' && name != 'undefined');
    };

    const carPaymentsChartData = {
        labelsData: [],
        valuesData: [],
        valuesData2: [],
        titleData: 'Poziom spłaty aut (netto)',
        stackedData: true
    };

    const financialChartData = {
        titleData: 'Wynik finansowy',
        labelsData: [""],
        valuesData: [""]
    }

    function openLasowiceReport() {
        Rest.getLasowiceCashReport();
    }

    function openIncomeDetails() {
        incomeDetailsShown = !incomeDetailsShown;
    }
</script>


<div class="row">
    <div class="col-12 col-lg-3 mt-4">
        <SingleNumberChart title="Dzienny zarobek netto" number="{dailyIncome}"></SingleNumberChart>
    </div>
    {#if incomePerDay > 0}
        <div class="col-12 col-lg-3 mt-4" style="text-align: center">
            <canvas id="foo" class="text-center flex flex-col chart-container">
            </canvas>
        </div>
    {/if}
    <div class="col-12 col-lg-3 mt-4 clickableElement" on:click={openLasowiceReport}>
        <SingleNumberChart title="Gotówka w Lasowicach" number="{lasowiceCash}"></SingleNumberChart>
    </div>
    <div class="col-12 col-lg-3 mt-4 clickableElement" on:click={openIncomeDetails}>
        <SingleNumberChart title="Wynik netto od początku miesiąca"
                           number="{nettoFromBeginningOfTheMonth}"></SingleNumberChart>
    </div>
</div>

{#if incomeDetailsShown}
    <div class="row">
        <div class="col-12 col-lg-3 mt-4">
            <SingleNumberChart title="Leasing i ubezpieczenie aut"
                               number="{reportData.financeStatsForCurrentMonth.carCosts*-1}"></SingleNumberChart>
        </div>
        <div class="col-12 col-lg-3 mt-4">
            <SingleNumberChart title="Inne koszty"
                               number="{reportData.financeStatsForCurrentMonth.costsNetto*-1}"></SingleNumberChart>
        </div>
        <div class="col-12 col-lg-3 mt-4">
            <SingleNumberChart title="Utarg"
                               number="{reportData.financeStatsForCurrentMonth.incomeNetto}"></SingleNumberChart>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-lg-3 mt-4">
        </div>
        <div class="col-12 col-lg-6 mt-4">
            <div class="text-center flex flex-col chart-container">
                <table class="table table-dark noMarginBottom smallFontOnMobile">
                    <thead>
                    <tr>
                        <th>Data początku wynajmu</th>
                        <th class="d-none d-sm-table-cell">Auto</th>
                        <th class="d-none d-sm-table-cell">Klient</th>
                        <th class="d-none d-sm-table-cell">Utarg</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each reportData.financeStatsForCurrentMonth.incomeDetails as rent, i}
                        <tr>
                            <td>{rent.date}</td>
                            <td class="d-none d-sm-table-cell">{rent.rent}</td>
                            <td class="d-none d-sm-table-cell">{rent.client}</td>
                            <td class="d-none d-sm-table-cell">{rent.income.toFixed(0)}</td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
{/if}

<div class="row">
    <div class="col-12 mt-4">
        <BarChart {...carPaymentsChartData} bind:this={carPaymentsChart}></BarChart>
    </div>
    <div class="col-12 mt-4 mb-4">
        {#if shouldShowOverallStats}
            <LineChart {...financialChartData} bind:this={financialChart}></LineChart>
        {/if}
    </div>
</div>

